import { DIRECTOR_NAME_REQUIRED, EMAIL_INVALID, EMAIL_REQUIRED } from '@/constants/MessageConstants'
import * as Yup from 'yup'

const EditDirectorValidationSchema = Yup.object().shape({
  name: Yup.string().required(DIRECTOR_NAME_REQUIRED),
  email: Yup.string().email(EMAIL_INVALID).required(EMAIL_REQUIRED),
})

export default EditDirectorValidationSchema
